import React from 'react';

const ValidationError = ({ error }) => {
    if (!error) return null;

    return (
        <div className="absolute top-full mt-1 text-crimson-500 text-xs bg-slate-950 px-1.5 py-0.5 rounded select-none whitespace-nowrap z-10" style={{
            left: '50%',
            transform: 'translateX(-50%)'
        }}>
            {error.message}
            <div className="absolute bottom-full border-l-4 border-r-4 border-b-4 border-t-0 border-l-transparent border-r-transparent border-slate-950" style={{
                height: '4px',
                width: '8px',
                left: '50%',
                transform: 'translateX(-50%)'
            }}></div>
        </div>
    );
};

export default ValidationError;